// Libraries
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { InfoHexagon } from "@untitled-ui/icons-react";

// Components
import { ButtonV2 } from "#src/commonV2/Button";
import ConfigSectionWrapperV2 from "#src/commonV2/helper/wrapper/ConfigSection";
import DeleteWorkspaceModal from "#src/components/workspace/details/DangerZone/DeleteModal";

// API-related
import { type IWorkspaceItem } from "#src/services/workspace";

interface IDeleteProps {
  currentWorkspace: IWorkspaceItem;
  workspaceId: string;
}

const WorkspaceDangerZone = ({
  currentWorkspace,
  workspaceId,
}: IDeleteProps) => {
  const { t } = useTranslation("workspace", { keyPrefix: "detail" });

  const [openConfirmDeleteWorkspace, setOpenConfirmDeleteWorkspace] =
    useState<boolean>(false);

  const onCloseModalConfirmDelete = () => {
    setOpenConfirmDeleteWorkspace(false);
  };

  return (
    <>
      <ConfigSectionWrapperV2
        danger
        icon={<InfoHexagon className="h-5 w-5 text-error-v2-600" />}
        headerTitle={t("deleteWorkspace.title")}
      >
        <div className="flex justify-between gap-8 p-4">
          <span className="text-md font-regular text-gray-v2-900 flex-1">
            {t("deleteWorkspace.description")}
          </span>
          <ButtonV2
            variant="primary"
            color="error"
            onClick={() => setOpenConfirmDeleteWorkspace(true)}
            className="h-fit"
          >
            {t("button.delete")}
          </ButtonV2>
        </div>
      </ConfigSectionWrapperV2>
      <DeleteWorkspaceModal
        workspaceId={workspaceId}
        open={openConfirmDeleteWorkspace}
        onClose={onCloseModalConfirmDelete}
        currentWorkspace={currentWorkspace}
      />
    </>
  );
};

export default WorkspaceDangerZone;
